import BrowserSpecific from 'app/components/common/BrowserSpecific';
import MessageModal from 'app/components/DeviceSetup/MessageModal';
import WithSkip from 'app/components/DeviceSetup/WithSkip';
import { tFunctionType, useI18n } from 'app/components/localization';
import { DeviceType } from 'app/containers/rtc/DeviceManagerContext';
import { OperatingSystem } from 'app/utils/userAgent';
import React, { FunctionComponent } from 'react';

const messagesPerType = {
  [DeviceType.Audio]: (t: tFunctionType) => ({
    title: t('rtc.device-setup.connect.audio.title'),
    message: t('rtc.device-setup.connect.audio.message'),
  }),
  [DeviceType.Video]: (t: tFunctionType) => ({
    title: t('rtc.device-setup.connect.video.title'),
    message: t('rtc.device-setup.connect.video.message'),
  }),
};

interface IProps {
  type: DeviceType;
}

const ConnectDevice: FunctionComponent<IProps> = (({ type }) => {
  const { t } = useI18n();
  const { title, message } = messagesPerType[type](t);

  return (
    <MessageModal
      title={title}
      buttons={<WithSkip type={type} />}
    >
      <p>{message}</p>
      <BrowserSpecific>{({ os }) =>
        // Tell macOS users they need to restart their browser
        // because USB hot-plugging is hard in 2018 (?!)
        os === OperatingSystem.macOS ?
          <p>{t('rtc.device-setup.connect.mac')}</p> :
        null
      }</BrowserSpecific>
    </MessageModal>
  );
});

export default ConnectDevice;
